export default "__VITE_ASSET__462ab05a__"